import axios from "axios"
import { useStoreActions, useStoreState } from "easy-peasy"
import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { beep } from "./beep.js"
import ErrorPopup from "./ErrorPopup.js"
import StatusPopup from "./StatusPopup.js"
import { DOG_FEES_EDIT_URL } from "./Constants.js"

function centsToDisplay(val) {
	if (val === "" || val === null || val === undefined) return ""
	return "$" + (Number(val) / 100).toFixed(2)
}

function displayToCents(val) {
	if (val === "" || val === null || val === undefined) return 0
	return Math.round(parseFloat(val.replace("$", "")) * 100)
}

const DogFees = () => {
	const d = new Date()
	const navigate = useNavigate()

	// easy-peasy
	const Token = useStoreState((state) => state.Token)
	const FeeList = useStoreState((state) => state.FeeList)
	const setFeeList = useStoreActions((actions) => actions.setFeeList)
	const setLoggedIn = useStoreActions((actions) => actions.setLoggedIn)
	const setHeaderCity = useStoreActions((actions) => actions.setHeaderCity)
	const setHeaderUser = useStoreActions((actions) => actions.setHeaderUser)

	const [error, setError] = useState("")
	const [status, setStatus] = useState("")
	const [fees, setFees] = useState({
		name: "",
		dog: "",
		sheep: "",
		goat: "",
		kennel: "",
		late: "",
		nofile: "",
		vicious: "",
		lost_tag: "",
		returned_check: "",
		impound: "",
		year: "",
		percent: "",
	})

	useEffect(() => {
		if (!FeeList || FeeList.length === 0) return
		const currentYear = d.getFullYear()
		const f =
			FeeList.find((row) => parseInt(String(row[13]).substring(0, 4)) === currentYear) ||
			[...FeeList].sort((a, b) => parseInt(String(b[13]).substring(0, 4)) - parseInt(String(a[13]).substring(0, 4)))[0]
		if (!f) return
		setFees({
			name: f[2],
			dog: centsToDisplay(f[3]),
			sheep: centsToDisplay(f[4]),
			goat: centsToDisplay(f[5]),
			kennel: centsToDisplay(f[6]),
			late: centsToDisplay(f[7]),
			nofile: centsToDisplay(f[8]),
			vicious: centsToDisplay(f[9]),
			lost_tag: centsToDisplay(f[11]),
			returned_check: centsToDisplay(f[10]),
			impound: centsToDisplay(f[12]),
			year: f[13],
			percent: f[14],
		})
	}, [FeeList])

	useEffect(() => {
		if (!error) return
		beep()
		const timer = setTimeout(() => {
			if (error === "401" || error.includes("401")) {
				setHeaderCity("CR Cloud Technology")
				setHeaderUser("None")
				setLoggedIn(false)
				navigate("/login")
			}
		}, 2000)
		return () => clearTimeout(timer)
	}, [error, navigate, setHeaderCity, setHeaderUser, setLoggedIn])

	const handleChange = (e) => {
		setFees({ ...fees, [e.target.name]: e.target.value })
		setError("")
		setStatus("")
	}

	async function handleSave(e) {
		e.preventDefault()
		setStatus("submitting")
		try {
			const dogCents = displayToCents(fees.dog)
			const sheepCents = displayToCents(fees.sheep)
			const goatCents = displayToCents(fees.goat)
			const kennelCents = displayToCents(fees.kennel)
			const lateCents = displayToCents(fees.late)
			const nofileCents = displayToCents(fees.nofile)
			const returnedCheckCents = displayToCents(fees.returned_check)
			const viciousCents = displayToCents(fees.vicious)
			const lostTagCents = displayToCents(fees.lost_tag)
			const impoundCents = displayToCents(fees.impound)
			const request = {
				login_id: Token.login_id,
				client_id: Token.client_id,
				fee_year: d.getFullYear(),
				name: fees.name,
				dog: dogCents,
				sheep: sheepCents,
				goat: goatCents,
				kennel: kennelCents,
				late: lateCents,
				nofile: nofileCents,
				returned_check: returnedCheckCents,
				vicious: viciousCents,
				lost_tag: lostTagCents,
				impound: impoundCents,
				percent: fees.percent,
			}
			await axios.post(DOG_FEES_EDIT_URL, request)
			const currentYear = d.getFullYear()
			const updatedFeeList = FeeList.map((row) => {
				if (parseInt(String(row[13]).substring(0, 4)) !== currentYear) return row
				const updated = [...row]
				updated[2] = fees.name
				updated[3] = dogCents
				updated[4] = sheepCents
				updated[5] = goatCents
				updated[6] = kennelCents
				updated[7] = lateCents
				updated[8] = nofileCents
				updated[9] = viciousCents
				updated[10] = returnedCheckCents
				updated[11] = lostTagCents
				updated[12] = impoundCents
				updated[14] = fees.percent
				return updated
			})
			setFeeList(updatedFeeList)
			setStatus("success")
			setTimeout(() => setStatus(""), 3000)
		} catch (err) {
			setError(err.message)
			if (err.message === "Request failed with status code 401") {
				setError("Timeout")
			}
			if (err.message === "Request failed with status code 422") {
				setError("422")
			}
			if (err.message === "Request failed with status code 500") {
				setError("500")
			}
		}
	}

	const feeRows = [
		{ label: "Name", name: "name" },
		{ label: "Dog", name: "dog" },
		{ label: "Goat", name: "goat" },
		{ label: "Impound", name: "impound" },
		{ label: "Kennel", name: "kennel" },
		{ label: "Late Filing", name: "late" },
		{ label: "Lost Tag", name: "lost_tag" },
		{ label: "No Filing", name: "nofile" },
		{ label: "Returned Check", name: "returned_check" },
		{ label: "Sheep", name: "sheep" },
		{ label: "Vicious", name: "vicious" },
		{ label: "Year", name: "year" },
		{ label: "Percent", name: "percent" },
	]

	return (
		<main className="Main" style={{ display: "flex", justifyContent: "center" }}>
			<fieldset className="fees" style={{ alignSelf: "flex-start" }} disabled>
				<legend>Fee Schedule</legend>
				<form name="InputForm" onSubmit={handleSave}>
					<table id="fees_table">
						<tbody>
							{feeRows.map((row) => (
								<tr key={row.name}>
									<td style={{ textAlign: "center", width: "140px" }}>
										<label htmlFor={row.name}>{row.label}</label>
									</td>
									<td style={{ textAlign: "center" }}>
										<input
											type="text"
											id={row.name}
											name={row.name}
											value={fees[row.name]}
											onChange={handleChange}
										/>
									</td>
								</tr>
							))}
						</tbody>
					</table>
					<div style={{ display: "flex", justifyContent: "center", marginTop: "1rem" }}>
					</div>
					<StatusPopup message={status === "success" ? "Fee schedule saved." : ""} />
					<ErrorPopup
						message={
							error === "Timeout" ? "Your session has timed out. Please login again." :
							error === "422" ? "Unable to use browser refresh button." :
							error === "500" ? "Unknown error — notify CR Cloud Technology." :
							error
						}
						onClose={() => setError("")}
					/>
				</form>
			</fieldset>
		</main>
	)
}

export default DogFees
